"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDataStream = exports.readableFrom = exports.iterableFromReadable = void 0;
const micro_errors = __importStar(require("@journeyapps-platform/micro-errors"));
const cross_stream = __importStar(require("./cross-stream"));
/**
 * Construct an AsyncIterator from a given ReadableStream.
 *
 * This is only really intended to be used from browser runtimes or within code intended to
 * be used cross-platform. This is because Node ReadableStreams already implement AsyncIterators
 */
async function* iterableFromReadable(readable) {
    const reader = readable.getReader();
    try {
        while (true) {
            const res = await reader.read();
            if (res.done) {
                return;
            }
            yield res.value;
        }
    }
    finally {
        reader.releaseLock();
    }
}
exports.iterableFromReadable = iterableFromReadable;
/**
 * Construct a ReadableStream from a given Iterable or AsyncIterable.
 *
 * If the given iterable is already a readable then this is a noop
 */
const readableFrom = (iterable, strategy) => {
    if (iterable instanceof cross_stream.Readable) {
        return iterable;
    }
    let resume;
    return new cross_stream.Readable({
        start(controller) {
            void (async function () {
                for await (const chunk of iterable) {
                    controller.enqueue(chunk);
                    if (controller.desiredSize != null && controller.desiredSize <= 0) {
                        await new Promise((resolve) => {
                            resume = resolve;
                        });
                    }
                }
                controller.close();
            })().catch((err) => {
                controller.error(err);
            });
        },
        async pull() {
            resume?.();
        }
    }, strategy);
};
exports.readableFrom = readableFrom;
/**
 * Yield a generator that validates data flowing through it
 */
async function* validateDataStream(iterable, validator) {
    for await (const chunk of iterable) {
        const res = validator.validate(chunk);
        if (!res.valid) {
            throw new micro_errors.ValidationError(res.errors);
        }
        yield chunk;
    }
}
exports.validateDataStream = validateDataStream;
